import { get } from 'lodash';
import { connect } from 'react-redux';
import { RedirectPurchase } from './redirect-purchase';

import {
  getCurrentUserMembership,
  getOrganizerMembership,
  getCurrentPurchase,
} from '../../selectors/purchase-selector';

export default function (ComposedComponent) {
  class VerifyOrganizer extends RedirectPurchase {
    get isOrganizer() {
      const orgID = get(this.props, 'organizerMembership.id', 'unclaimed');
      return orgID === get(this.props, 'currentUserMembership.id');
    }

    redirectTo() {
      if (!this.isOrganizer) {
        return `/purchases/${this.props.purchase.slug}`;
      };

      return false;
    }
  }

  const mapStateToProps = (state) => {
    return {
      purchase: getCurrentPurchase(state),
      currentUserMembership: getCurrentUserMembership(state),
      organizerMembership: getOrganizerMembership(state),
      composedComponent: ComposedComponent,
    };
  };

  const mapDispatchToProps = {
  };

  return connect(mapStateToProps, mapDispatchToProps)(VerifyOrganizer);
}



// WEBPACK FOOTER //
// ./src/components/hoc/verify-organizer.js